// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.startCircle {
    font-family: 'Poppins', sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background-color: var(--vert);
    border: solid transparent;
    border-radius: 3rem;
}

.startCircle:hover {
    border: 2px solid black;
    cursor: pointer;
}

.startButton {
    color: #fff;
    font-size: 14px;
}

.stop {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background-color: var(--rouge);
    border: solid transparent;
    border-radius: 3rem;
}

.stop:hover {
    border: 2px solid black;
    cursor: pointer;
}

.desactiveCircle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    background-color: var(--gris);
    border: solid transparent;
    border-radius: 3rem;
}

/*.historique {
    font-size: 0.5rem;
}

.historique:hover {
    font-size: 0.5rem;
    cursor: pointer;
}
*/
/*.details {
    color: var(--noir);
    background-color: transparent;
    border: transparent;
    font-family: 'Poppins', sans-serif;
    font-size: 0.5rem;*/
/* margin-left: 9.3rem;*/
/*}*/

/*.details:hover {
    text-decoration: underline;
    color: var(--bleu);
    cursor: pointer;
}*/



.loading {
    display: none;
}

.loading.active {
    display: block;
}

.infoBox {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    padding: 0 10px;
    width: 100%;
}

.divOccupe {

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    color: var(--blanc);
    text-transform: uppercase;
    border-radius: 6px;
    font-size: 16px;
    font-family: Poppins, sans-serif;

}

.backr {
    background-color: var(--rouge);
}

.backv {
    background-color: var(--vert);
}

.backg {
    background-color: var(--gris);
}

button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.flexCol {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.timeZoneActions {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 10px;
    padding: 6px;
    background: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 10px;
    color: var(--ecriture);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    font-size: 0.9rem;
    margin: 0 auto;
    transition: all 0.3s ease;
    width: 100%;
}

.pcDisconnected {
    display: flex;
    align-items: center;
    gap: 6px;
    color: red;
}

.redDot {
    display: block;
    width: 6px;
    height: 6px;
    background-color: red;
    border-radius: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Start/Start.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;;;;;;;CAQC;AACD;;;;;uBAKuB;AACvB,wBAAwB;AACxB,IAAI;;AAEJ;;;;EAIE;;;;AAIF;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gCAAgC;;AAEpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,mBAAmB;AACvB","sourcesContent":[".startCircle {\n    font-family: 'Poppins', sans-serif;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 50px;\n    height: 50px;\n    background-color: var(--vert);\n    border: solid transparent;\n    border-radius: 3rem;\n}\n\n.startCircle:hover {\n    border: 2px solid black;\n    cursor: pointer;\n}\n\n.startButton {\n    color: #fff;\n    font-size: 14px;\n}\n\n.stop {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 50px;\n    height: 50px;\n    background-color: var(--rouge);\n    border: solid transparent;\n    border-radius: 3rem;\n}\n\n.stop:hover {\n    border: 2px solid black;\n    cursor: pointer;\n}\n\n.desactiveCircle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 50px;\n    height: 50px;\n    background-color: var(--gris);\n    border: solid transparent;\n    border-radius: 3rem;\n}\n\n/*.historique {\n    font-size: 0.5rem;\n}\n\n.historique:hover {\n    font-size: 0.5rem;\n    cursor: pointer;\n}\n*/\n/*.details {\n    color: var(--noir);\n    background-color: transparent;\n    border: transparent;\n    font-family: 'Poppins', sans-serif;\n    font-size: 0.5rem;*/\n/* margin-left: 9.3rem;*/\n/*}*/\n\n/*.details:hover {\n    text-decoration: underline;\n    color: var(--bleu);\n    cursor: pointer;\n}*/\n\n\n\n.loading {\n    display: none;\n}\n\n.loading.active {\n    display: block;\n}\n\n.infoBox {\n    box-sizing: border-box;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n    padding: 0 10px;\n    width: 100%;\n}\n\n.divOccupe {\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px 10px;\n    color: var(--blanc);\n    text-transform: uppercase;\n    border-radius: 6px;\n    font-size: 16px;\n    font-family: Poppins, sans-serif;\n\n}\n\n.backr {\n    background-color: var(--rouge);\n}\n\n.backv {\n    background-color: var(--vert);\n}\n\n.backg {\n    background-color: var(--gris);\n}\n\nbutton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.flexCol {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.timeZoneActions {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 10px;\n    padding: 6px;\n    background: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    color: var(--ecriture);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n    font-size: 0.9rem;\n    margin: 0 auto;\n    transition: all 0.3s ease;\n    width: 100%;\n}\n\n.pcDisconnected {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    color: red;\n}\n\n.redDot {\n    display: block;\n    width: 6px;\n    height: 6px;\n    background-color: red;\n    border-radius: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
